import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, { style: {"padding-right":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("p", null, "By impression, totally", -1),
                    _createElementVNode("h2", null, [
                      _createElementVNode("b", null, "Have you heard of the professions below?")
                    ], -1)
                  ])),
                  _: 1,
                  __: [2]
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal(true)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_toolbar, { style: {"--min-height":"32px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Yes: " + _toDisplayString(_ctx.getProfessionResponseCount('Yes')) + " | No: " + _toDisplayString(_ctx.getProfessionResponseCount('No')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_progress_bar, {
          value: _ctx.getResponseProgress()
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professions.slice(0, 50), (profession, idx) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                lines: "full",
                key: idx
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(profession.name), 1),
                      _createElementVNode("p", null, _toDisplayString(profession.nameChinese), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_chip, {
                    onClick: ($event: any) => (_ctx.updateProfessionResponse(profession, 'Yes')),
                    outline: profession.userResponse != 'Yes',
                    disabled: profession.userResponse == 'Yes'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("Yes")
                        ])),
                        _: 1,
                        __: [3]
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick", "outline", "disabled"]),
                  _createVNode(_component_ion_chip, {
                    onClick: ($event: any) => (_ctx.updateProfessionResponse(profession, 'No')),
                    outline: profession.userResponse != 'No',
                    disabled: profession.userResponse == 'No'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("No")
                        ])),
                        _: 1,
                        __: [4]
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick", "outline", "disabled"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              expand: "block",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitProfessionResponses(_ctx.updatedProfessionResponses)))
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode(" Save ")
              ])),
              _: 1,
              __: [5]
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}